import createModel from "../createModel";
import { UniqaIncident } from "./UniqaIncident";
import { UniqaClaim } from "./UniqaClaim";

export const UniqaIncidentDetail = createModel("UniqaIncidentDetail", (json) => ({
    detail: UniqaIncident.fromServer(json.detail),
    claims: UniqaClaim.fromServerList(json.claims),
}));
